/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getMasterValues: (params) => {
    return axios.get(API_ENDPOINTS.GET_SITE_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
      params,
    });
  },
  sitelogoupload: (data) => {
      //console.log("userId:", userID);
      //console.log("image:", image);
      return axios.put(API_ENDPOINTS.SITE_IMAGE_UPLOAD+'/',data, {
        headers: {
          isAuthRequired: true,
          "Content-Type": "multipart/form-data",
        },
      });
    },
  updateMasterValues: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SITE_SETTINGS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getProfileDetails: (data) => {
    return axios.post(API_ENDPOINTS.PROFILE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateProfileDetails: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PROFILE+'/'+data.userID, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updatePassword: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PASSWORD+'/'+data.userID, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateAppState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_APP_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateSmsState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SMS_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },

  //

  getPaymentSettings: () => {
    return axios.get(API_ENDPOINTS.GET_PAYMENT_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  updatePaymentSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PAYMENT_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  getPlatformSettings: (params) => {
    return axios.get(API_ENDPOINTS.GET_PLATFORM_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
      params,
    });
  },

  updatePlatformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PLATFORM_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  getuserRewardformSettings: () => {
    return axios.get(API_ENDPOINTS.GET_USER_REWARD_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  updateuserRewardformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_USER_REWARD_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  getBusinessSettings: (params) => {
    return axios.get(API_ENDPOINTS.GET_BUSINESS_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
      params,
    });
  },

  updateBusinessSettings: (data) => {
    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;

    return axios.put(API_ENDPOINTS.UPDATE_BUSINESS_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
    });
  },

  getUserDetails: () => {
    return axios.get(API_ENDPOINTS.GET_USER_DETAILS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  changeUserPassword: (id, data) => {
    const url = `${API_ENDPOINTS.UPDATE_USER_PASSWORD}/${id}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  getLegalSettings: (params) => {
    return axios.get(API_ENDPOINTS.GET_LEGAL_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
      params,
    });
  },

  updateLegalSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_LEGAL_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },

  getprivacySettings: (params) => {
    return axios.get(API_ENDPOINTS.GET_PRIVACY_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
       params,
    });
  },

  updateprivacySettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PRIVACY_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
};
